export default {"src":"/_next/static/media/wc.7a3612ba.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};